/**
 * Proxy object to accept commands for LGR
 */
class CommandProxy {
    constructor(fitFunction, zoomFunction) {
        this.fit = () => {
            this._fitFunction();
        };
        this.zoomIn = () => {
            this._zoomFunction(0.1);
        };
        this.zoomOut = () => {
            this._zoomFunction(-0.1);
        };
        this._fitFunction = fitFunction;
        this._zoomFunction = zoomFunction;
    }
}
export default CommandProxy;
